// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@synd/App/SharedStyles/CartLineSharedStyles";
import { cartLineCardExpandedStyles } from "@synd/Overrides/Components/CartLineCardExpanded";
import { css } from "styled-components";

cartLineCardExpandedStyles.costCodeLabelText = {
    ...cartLineSharedStyles.costCodeLabelText,
};

cartLineCardExpandedStyles.costCodeValueText = {
    ...cartLineSharedStyles.costCodeValueText,
};

cartLineCardExpandedStyles.extendedUnitNetPrice = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};

cartLineCardExpandedStyles.subtotalWithoutVatText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};

cartLineCardExpandedStyles.vatAmount = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};

cartLineCardExpandedStyles.cartLineErrorMessageText = {
    color: "danger",
};

cartLineCardExpandedStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

cartLineCardExpandedStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

cartLineCardExpandedStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

cartLineCardExpandedStyles.price = {
    ...cartLineSharedStyles.productPrice,
};

cartLineCardExpandedStyles.configurationContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;
    `,
};

cartLineCardExpandedStyles.configurationOptionLabel = {
    ...cartLineSharedStyles.configurationOptionLabel,
};

cartLineCardExpandedStyles.configurationOptionText = {
    ...cartLineSharedStyles.configurationOptionText,
};

cartLineCardExpandedStyles.promotionNameLabel = {
    ...cartLineSharedStyles.promotionNameLabel,
};

cartLineCardExpandedStyles.promotionNameText = {
    ...cartLineSharedStyles.promotionNameText,
};

cartLineCardExpandedStyles.imageWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

cartLineCardExpandedStyles.imageBadges = {
    container: {
        css: css`
            margin-top: 8px;
        `,
    },
};

cartLineCardExpandedStyles.cartLineErrorMessageWrapper = {
    ...cartLineSharedStyles.cartLineErrorMessageWrapper,
};
